// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__mlZBu","faqHeader":"style_faqHeader__79110","icon":"style_icon__L+-27","main":"style_main__4yR8g","subMain":"style_subMain__vadXn"};